import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Admin from '@/views/Admin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页 - 文盛化工'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: {
      title: '产品中心 - 文盛化工'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: {
      title: '关于我们 - 文盛化工'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: {
      title: '联系我们 - 文盛化工'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '管理员登录 - 文盛化工'
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: '管理后台 - 文盛化工',
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 设置默认页面标题
document.title = '文盛化工 - 专业化工原料供应商'

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 检查是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    const adminAuth = localStorage.getItem('adminAuth')
    
    // 如果没有任何认证信息，直接跳转到登录页
    if (!token || adminAuth !== 'true') {
      next('/login')
      return
    }
    
    // 如果store中认证状态为false但localStorage有认证信息，需要恢复状态
    if (!store.state.isAuthenticated) {
      try {
        // 异步检查认证状态
        await store.dispatch('checkAuthStatus')
        // 检查完成后再次确认认证状态
        if (store.state.isAuthenticated) {
          next()
        } else {
          next('/login')
        }
      } catch (error) {
        console.error('认证状态检查失败:', error)
        next('/login')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router